import { Component, OnInit, Input, OnDestroy, Output, EventEmitter, forwardRef, SimpleChanges, OnChanges } from '@angular/core';
import { Relationship } from '../models/UserRelationship';
import { UserRelationshipService } from '../user-relationship.service';
import { Subscription } from 'rxjs';
import { PartnerRelationship } from '../models/PartnerRelationship';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NG_VALIDATORS, Validator, AbstractControl, ValidationErrors } from '@angular/forms';
import { PartnershipService } from '../partnership.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-partnership-dropdown',
  templateUrl: './partnership-dropdown.component.html',
  styleUrls: ['./partnership-dropdown.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PartnershipDropdownComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => PartnershipDropdownComponent),
      multi: true
    }
  ]
})
export class PartnershipDropdownComponent implements OnInit, OnDestroy, ControlValueAccessor, Validator, OnChanges{
  @Input() relationship: Relationship[];
  @Input() filterPlaceHolder: string;
  @Input() defaultLabel: string;
  @Input() maxSelectedLabels: number;
  @Input() readOnly: boolean;
  @Input() relationshipExclude: Relationship[] = [];
  @Input() relationshipInclude: Relationship[] = [];
  @Output() onPartnershipCount = new EventEmitter<number>();
  @Output() onChange = new EventEmitter<Relationship[]>();

  subscription: Subscription;
  partnerRelationship: PartnerRelationship[];
  partnership: Relationship[];
  partnershipSelected: Relationship[];
  disabled: boolean;
  processing = false;

  public onModelChange: (newValue: any) => void = () => {};
  public onModelTouched: (flag: boolean) => void = () => {};

  writeValue(value: any): void {
    this.relationship = value ?  value : this.relationship;
  }

  registerOnChange(fn: any): void {
    this.onModelChange = fn;
  }

  registerOnTouched(fn: any): void {
      this.onModelTouched = fn;
  }

  setDisabledState(val: boolean): void {
    this.disabled = val;
  }

  validate(c: AbstractControl): ValidationErrors | null {
    return c.value ? null : { invalidForm: {valid: false, message: 'Please select an option'}};
  }

  constructor(private userRelationshipSvc: UserRelationshipService, private partnershipSvc: PartnershipService) { }

  ngOnInit() {
    this.populateData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.relationship && changes.relationship.currentValue
      && changes.relationship.previousValue && changes.relationship.currentValue.length === 0) {
      this.partnershipSelected = [];
      this.includePartnership();
      this.excludePartnership();
    }
  }

  populateData() {
    this.processing = true;
    this.subscription = this.partnershipSvc.findByPerson()
    .subscribe((user: any) => {
        this.partnership = [];
        this.partnerRelationship = <PartnerRelationship[]>user.data;

        this.partnerRelationship.map((relationship: PartnerRelationship, index) => {
          this.partnership.push({Id: relationship.RelationshipId
            , Company: relationship.ParentCompany
            , RelationshipName: relationship.ParentCompany.Name + ' - ' + relationship.ChildCompany.Name});
        });

        this.excludePartnership();

        this.partnershipSelected = this.partnership.filter((relation: Relationship) =>
          this.relationship.map((res) => res.Id ).indexOf(relation.Id) !== -1
        );
        this.onPartnershipCount.emit(this.partnership.length);
        this.onModelChange(this.partnershipSelected);
        this.onChange.emit(this.partnershipSelected);
        this.processing = false;
    });
  }

  excludePartnership(): void {
    this.partnership = this.partnership.filter((relation: Relationship) =>
      this.relationshipExclude.map((res) => res.Id).indexOf(relation.Id) === -1
    );
  }

  includePartnership(): void {
    this.relationshipInclude.map((relationship: Relationship, index) => {
      this.partnership.push({Id: relationship.Id
        , Company: relationship.Company
        , RelationshipName: relationship.RelationshipName});
    });
    _.orderBy(this.partnership, ['RelationshipName'], ['asc']);
  }

  change(newValue: any) {
    this.onModelChange(newValue);
    this.onChange.emit(newValue);
  }

  blur() {
    this.onModelTouched(true);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
